module.exports = __webpack_public_path__ + "static/img/USC_Marshall_CurriculumMap_2023_WBB_R2.c240f5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/USC_Marshall_CurriculumMap_2023_WBB_R2.png
// module id = eHl1
// module chunks = 1